import { Content, Component, Element } from './DataStructures';
const e = {
  Audio: new Component({
    tagName: "AudioPlayer",
    props: {
      src: "",
      trackSource: "",
      completed: undefined
    }
  }),
  Callout: new Component({
    tagName: "TaskCallout",
    props: {
      picture: "https://upload.wikimedia.org/wikipedia/commons/thumb/3/3a/Cat03.jpg/1200px-Cat03.jpg",
      details: new Content("An accessible description of the figure."),
      detailsName: "calloutdesc",
      alt: "Alt text for the callout.",
      hotspots: [{
        content: new Content("meow!"),
        label: "cat",
        style: {
          top: "0px",
          left: "0px",
          width: "150px",
          height: "150px"
        },
        shape: "Square"
      }]
    }
  }),
  Carousel: new Component({
    tagName: "TaskCarousel",
    props: {
      items: [new Content("Slide 1"), new Content("Slide 2"), new Content("Slide 3")]
    }
  }),
  "Chord Builder": new Component({
    tagName: "TaskChordBuilder",
    props: {
      musicConfiguration: "X:1;L:1/1;M:4/4;K:Cmaj treble",
      musicInitial: "[]",
      musicButtonNote: true,
      musicButtonFlat: true,
      musicButtonSharp: true,
      musicButtonNatural: false,
      musicButtonDoubleFlat: false,
      musicButtonDoubleSharp: false,
      musicDuration: "1000",
      correct: "[CEG]",
      feedbackCorrect: new Content("Correct!"),
      feedbackIncorrect: new Content("Incorrect. The answer is C E G."),
      answers: [{
        answer: "[CEG]",
        correct: true,
        feedback: "Very true"
      }, {
        answer: "[C'E'G']",
        correct: true,
        feedback: "This is also very true"
      }]
    }
  }),
  "Custom HTML": new Component({
    tagName: "TaskCustom",
    props: {
      inner: `<div>hello world!</div>`
    }
  }),
  "Design Row": new Component({
    tagName: "DesignRow",
    props: {
      children: [new Component({
        tagName: "TaskSelect",
        props: {
          options: [new Content("A"), new Content("B"), new Content("C")],
          dropDownWidth: "100px",
          correct: 0,
          inline: true,
          label: new Content("1"),
          description: new Content("")
        }
      }), new Component({
        tagName: "TaskSelect",
        props: {
          options: [new Content("D"), new Content("E"), new Content("F")],
          dropDownWidth: "100px",
          correct: 1,
          inline: true,
          label: new Content("2"),
          description: new Content("")
        }
      })]
    }
  }),
  "Drag Drop": new Component({
    tagName: "TaskDragDrop",
    props: {
      responsive: true,
      randomize: true,
      labelWidth: "100px",
      picture: "https://upload.wikimedia.org/wikipedia/commons/thumb/3/3a/Cat03.jpg/1200px-Cat03.jpg",
      pictureAlt: new Content("placeholder alt text"),
      dropdownPlacement: "auto",
      pictureWidth: "560px",
      choices: [{
        content: new Content("Choice 0"),
        accessible: "choice0",
        accessibleLabel: "Choice 0"
      }, {
        content: new Content("Choice 1"),
        accessible: "choice1",
        accessibleLabel: "Choice 1"
      }, {
        content: new Content("Choice 2"),
        accessible: "choice2",
        accessibleLabel: "Choice 2"
      }],
      correctFeedback: new Content("Correct!"),
      incorrectFeedback: new Content("Incorrect."),
      hotspots: [{
        correct: [0],
        hotspotLabel: new Content("An accessible description of hotspot 0"),
        style: {
          top: "190px",
          left: "10px",
          width: "150px",
          height: "120px"
        }
      }, {
        correct: [1],
        hotspotLabel: new Content("An accessible description of hotspot 1"),
        style: {
          top: "190px",
          left: "200px",
          width: "150px",
          height: "120px"
        }
      }, {
        correct: [2],
        hotspotLabel: new Content("An accessible description of hotspot 2"),
        style: {
          top: "190px",
          left: "360px",
          width: "150px",
          height: "120px"
        }
      }]
    }
  }),
  Element: new Element({
    tagName: '',
    children: new Content("HTML Element")
  }),
  "Image Click": new Component({
    tagName: "TaskImageClick",
    props: {
      picture: "https://upload.wikimedia.org/wikipedia/commons/thumb/3/3a/Cat03.jpg/1200px-Cat03.jpg",
      alt: "A literal description of the image.",
      details: new Content("A figurative description of the image."),
      photoCredit: new Content(""),
      hotspots: [{
        correct: true,
        label: new Content("left ear"),
        feedback: new Content("Correct! Left ear."),
        style: {
          top: "0px",
          left: "0px",
          width: "50px",
          height: "50px"
        },
        shape: "Square"
      }]
    }
  }),
  "Image Figure": new Component({
    tagName: 'Figure',
    props: {
      src: "https://upload.wikimedia.org/wikipedia/commons/thumb/3/3a/Cat03.jpg/1200px-Cat03.jpg",
      caption: new Content("A figurative description of the image."),
      alt: "A literal description of the image.",
      longAlt: new Content(""),
      photoCredit: new Content("")
    }
  }),
  "Simple Image": new Component({
    tagName: "Image",
    props: {
      src: "https://upload.wikimedia.org/wikipedia/commons/thumb/1/18/Dog_Breeds.jpg/800px-Dog_Breeds.jpg",
      alt: "A literal description of the image.",
      longAlt: new Content("")
    }
  }),
  "Image Figure List": new Component({
    tagName: 'FigureList',
    props: {
      caption: new Content("A figurative description of the image."),
      photoCredit: new Content(""),
      imgHeight: '200px',
      placeContent: 'center',
      flexDirection: 'row'
    },
    children: [new Component({
      tagName: 'FigureList.Item',
      props: {
        src: "https://upload.wikimedia.org/wikipedia/commons/thumb/3/3a/Cat03.jpg/1200px-Cat03.jpg",
        alt: "A literal description of the image.",
        longAlt: new Content("")
      }
    }), new Component({
      tagName: 'FigureList.Item',
      props: {
        src: "https://upload.wikimedia.org/wikipedia/commons/thumb/3/3a/Cat03.jpg/1200px-Cat03.jpg",
        alt: "A literal description of the image.",
        longAlt: new Content("")
      }
    })]
  }),
  "Likert Scale": new Component({
    tagName: "TaskLikertScale",
    props: {
      intervals: 5,
      prompt: "How do you feel about _?",
      labels: [new Content("Opposed"), new Content("Concerned"), new Content("Unsure"), new Content("Optimistic"), new Content("Enthusiastic")]
    }
  }),
  "Multi-Choice": new Component({
    tagName: "TaskMultiChoice",
    props: {
      prompt: new Content("Question text goes here?"),
      choices: [new Content("Option 1"), new Content("Option 2"), new Content("Option 3")],
      correct: [0],
      feedback: [new Content("Option 1 feedback"), new Content("Option 2 feedback"), new Content("Option 3 feedback")],
      randomize: false,
      maxAttempts: -1,
      cols: 1,
      justifyChoices: "left"
    }
  }),
  "Multi-Drop Submit": new Component({
    tagName: "TaskDragDrop",
    props: {
      responsive: true,
      randomize: true,
      disableClipping: true,
      labelWidth: "60px",
      picture: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAASIAAACuCAMAAAClZfCTAAAAA1BMVEX///+nxBvIAAAASElEQVR4nO3BMQEAAADCoPVPbQhfoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABeA8XKAAFZcBBuAAAAAElFTkSuQmCC",
      pictureAlt: new Content("placeholder alt text"),
      pictureWidth: "560px",
      submit: true,
      choices: [{
        content: new Content("A"),
        accessible: "A",
        accessibleLabel: "A"
      }, {
        content: new Content("B"),
        accessible: "B",
        accessibleLabel: "B"
      }, {
        content: new Content("C"),
        accessible: "C",
        accessibleLabel: "C"
      }, {
        content: new Content("D"),
        accessible: "D",
        accessibleLabel: "D"
      }, {
        content: new Content("E"),
        accessible: "E",
        accessibleLabel: "E"
      }, {
        content: new Content("F"),
        accessible: "F",
        accessibleLabel: "F"
      }],
      correctFeedback: new Content("Correct!"),
      incorrectFeedback: new Content("Incorrect."),
      hotspots: [{
        correct: [0, 1],
        hotspotLabel: new Content(" "),
        style: {
          top: "100px",
          left: "10px",
          width: "150px",
          height: "120px"
        }
      }, {
        correct: [2, 3],
        hotspotLabel: new Content(" "),
        style: {
          top: "100px",
          left: "200px",
          width: "150px",
          height: "120px"
        }
      }, {
        correct: [4, 5],
        hotspotLabel: new Content(" "),
        style: {
          top: "100px",
          left: "390px",
          width: "150px",
          height: "120px"
        }
      }]
    }
  }),
  "Multi-Select": new Component({
    tagName: "TaskMultiSelect",
    props: {
      prompt: new Content("Question text goes here?"),
      data: [{
        label: "Label 1",
        correct: true
      }, {
        label: "Label 2",
        correct: true
      }, {
        label: "Incorrect label",
        correct: false
      }],
      correctFeedback: new Content("Correct."),
      incorrectFeedback: new Content("Incorrect.")
    }
  }),
  "Multi-Select Submit": new Component({
    tagName: "TaskMultiSelectSubmit",
    props: {
      prompt: new Content("Select the correct answer(s):"),
      data: [{
        value: new Content("correct answer"),
        correct: true
      }, {
        value: new Content("correct"),
        correct: true
      }, {
        value: new Content("incorrect"),
        correct: false
      }],
      buttonWidth: "85px",
      correctFeedback: new Content("Correct."),
      incorrectFeedback: new Content("Incorrect.")
    }
  }),
  "Music Viewer": new Component({
    tagName: "TaskMusicViewer",
    props: {
      musicConfiguration: "X:1;L:1/1;M:;K:C treble",
      musicInitial: "dBAGFD",
      musicPlayButton: true,
      musicDuration: 1000,
      rangeLower: -10,
      rangeHigher: 20
    }
  }),
  Paragraph: new Element({
    tagName: 'p',
    children: new Content("Lorem ipsum dolor sit amet")
  }),
  "Passage Click": new Component({
    tagName: "TaskPassageClick",
    props: {
      prompt: new Content("Lorem ipsum dolor sit amet"),
      multiFeedbackCorrect: new Content("")
    },
    children: new Content(new Element({
      tagName: 'p',
      children: new Content("This ", new Component({
        tagName: "TaskPassageClick.Click",
        props: {
          feedback: new Content("Feedback text here"),
          correct: true
        },
        children: new Content("text")
      }), " is highlighted.  This ", new Component({
        tagName: "TaskPassageClick.Click",
        props: {
          feedback: new Content("Feedback text here"),
          correct: false
        },
        children: new Content("other text")
      }), " is also highlighted.")
    }))
  }),
  "Passage Reveal": new Component({
    tagName: "TaskPassageReveal",
    props: {
      noReveal: false
    },
    children: new Content("This ", new Component({
      tagName: "TaskPassageReveal.Passage",
      props: {
        color: "#dabeef"
      },
      children: new Content("text")
    }), " is highlighted.")
  }),
  "Passage Hover": new Component({
    tagName: "TaskPassageReveal",
    props: {
      noReveal: true
    },
    children: new Content("This ", new Component({
      tagName: "TaskPassageReveal.Passage",
      props: {
        color: "#dabeef",
        contents: new Content("This content appears in a tooltip.")
      },
      children: new Content("text")
    }), " is highlighted.")
  }),
  "Scale Builder": new Component({
    tagName: "TaskScaleBuilder",
    props: {
      musicConfiguration: "X:1;L:1/1;M:;K:C treble",
      musicInitial: "zzzzzzzz",
      answers: [{
        answer: "FGA_BC'D'E'F'",
        correct: true,
        feedback: "Very true"
      }, {
        answer: "FGA_BC'D'E'G'",
        correct: false,
        feedback: "This is incorrect"
      }],
      musicButtonNote: true,
      musicButtonFlat: true,
      musicButtonSharp: true,
      musicButtonNatural: false,
      musicButtonDoubleFlat: false,
      musicButtonDoubleSharp: false,
      musicDuration: 1000,
      feedbackCorrect: "Correct!",
      feedbackIncorrect: "Incorrect.",
      rangeLower: -10,
      rangeHigher: 20
    }
  }),
  "Select (Dropdown)": new Component({
    tagName: "TaskSelect",
    props: {
      options: [new Content("Apples"), new Content("Oranges"), new Content("Pears")],
      buttonWidth: "100px",
      matchWidth: "button",
      correct: 1,
      inline: true,
      label: new Content("In general, "),
      description: new Content(" are a good source of Vitamin C.")
    }
  }),
  "Sorting": new Component({
    tagName: "TaskSorting",
    props: {
      feedbackCorrect: new Content("You got it right."),
      feedbackIncorrect: new Content("You got it wrong."),
      prompt: new Content("Sort these options into their containers."),
      categories: [new Content("Category 1"), new Content("Category 2")]
    },
    children: [new Component({
      tagName: "TaskSorting.Option",
      props: {
        category: 0
      },
      children: new Content("Lorem ipsum category 1")
    }), new Component({
      tagName: "TaskSorting.Option",
      props: {
        category: 1
      },
      children: new Content("Lorem ipsum category 2")
    })]
  }),
  "Tab Panel": new Component({
    tagName: "TaskTabPanel",
    props: {
      label: "tabs",
      contents: [{
        title: new Content("Tab 1"),
        contents: new Content("Tab 1")
      }, {
        title: new Content("Tab 2"),
        contents: new Content("Tab 2")
      }, {
        title: new Content("Tab 3"),
        contents: new Content("Tab 3")
      }, {
        title: new Content("Tab 4"),
        contents: new Content("Tab 4")
      }]
    }
  }),
  Tree: new Component({
    tagName: "TaskTree",
    children: new Content("You come across two doors. Which door do you choose?"),
    props: {
      paths: [{
        buttonProps: {
          children: new Content("Door 1")
        },
        content: new Content(new Component({
          tagName: "TaskTree",
          children: new Content("You win a new car! Double or nothing?"),
          props: {
            paths: [{
              buttonProps: {
                children: new Content("Double")
              },
              content: new Content(new Component({
                tagName: "TaskTree",
                children: new Content("You win two new cars!"),
                props: {
                  paths: []
                }
              }))
            }, {
              buttonProps: {
                children: new Content("Nothing")
              },
              content: new Content(new Component({
                tagName: "TaskTree",
                children: new Content("You win nothing."),
                props: {
                  paths: []
                }
              }))
            }]
          }
        }))
      }, {
        buttonProps: {
          children: new Content("Door 2")
        },
        content: new Content(new Component({
          tagName: "TaskTree",
          children: new Content("You win nothing."),
          props: {
            paths: []
          }
        }))
      }]
    }
  }),
  "True-False": new Component({
    tagName: "TaskTrueFalse",
    props: {
      question: new Content("The sky is blue."),
      correct: true,
      correctFeedback: new Content("The blue color comes from the reflection of the sea. (????)"),
      incorrectFeedback: new Content("Incorrect.")
    }
  }),
  "Columns": new Component({
    tagName: 'Row',
    children: new Content(new Component({
      tagName: 'Col',
      props: {
        md: 6
      },
      children: new Content(new Element({
        tagName: 'p',
        children: new Content("Lorem ipsum dolor sit amet")
      }))
    }), new Component({
      tagName: 'Col',
      props: {
        md: 6
      },
      children: new Content(new Element({
        tagName: 'p',
        children: new Content("Amet sit dolor ipsum lorem")
      }))
    }))
  }),
  "Voice Builder": new Component({
    tagName: "TaskVoiceBuilder",
    props: {
      musicConfiguration: "%%annotationfont Times-Roman 14;X:1;L:1/4;M:;K:D;%%staves {(S A) (T B N)} ",
      musicAnnotation: `"@-65,-60 D:" "@-7,-60 III\\201"x "@-4,-60 ii" "@6,-60 ⁶"x "@-11,-60 V" "@-4,-60 \\202" "@10,-60 ⁷" "@10,-60 ₅"x "@4,-60 I"x`,
      musicInitial: "x x x x ; C B, _E D; F, E, G, F, ; F,, G,, A,, D,",
      answers: [{
        answer: "^A B C' D' ; C B, _E D; F, E, G, F, ; F,, G,, A,, D,",
        correct: true,
        feedback: "Very true"
      }],
      musicDuration: "3500",
      musicButtonFlat: true,
      musicButtonSharp: true,
      musicButtonNatural: true,
      musicButtonDoubleSharp: false,
      musicButtonDoubleFlat: false,
      musicButtonSATB: true,
      musicButtonSoprano: true,
      musicButtonAlto: false,
      musicButtonTenor: false,
      musicButtonBass: false,
      feedbackCorrect: new Content(`In an augmented triad, the interval between the root and third is a major third and the interval between the root and fifth is an augmented fifth. So, F–A–C spells an augmented triad on an F root.`),
      feedbackIncorrect: new Content(`Listen to the triad again. It contains a major third between the root and third. What is the quality of the interval between the root and fifth?`)
    }
  })
};
export default e;